module.exports = __webpack_public_path__ + "static/media/gradientHero.d30e4816.mp4";